import type { LabelColor } from 'src/components/label/types';

/**
 * Статусы Ozon в API — snake_case; для UI: слова с пробелами, без подчёркиваний (как в категориях вкладок).
 */
export function formatOzonPostingStatusLabel(raw: string | null | undefined): string {
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw)
    .trim()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/** Соответствие цвета Label вкладкам: awaiting / delivering / delivered / cancelled. */
export function getOzonPostingStatusLabelColor(status: string | null | undefined): LabelColor {
  const s = String(status ?? '').trim().toLowerCase();
  if (s === 'delivering') return 'warning';
  if (s === 'delivered') return 'success';
  if (s === 'cancelled') return 'error';
  return 'default';
}

/** Цвет текста статуса в таблице (без компонента Label), в духе вкладок категорий. */
export function getOzonPostingStatusSxColor(
  status: string | null | undefined
): 'text.primary' | 'warning.main' | 'success.main' | 'error.main' {
  const c = getOzonPostingStatusLabelColor(status);
  if (c === 'default') return 'text.primary';
  return `${c}.main` as 'warning.main' | 'success.main' | 'error.main';
}
